export enum CustomContentAccordionListId {
  StartPageBanner = 'startPageBanner',
  HeroImagePromotion = 'heroImagePromotion'
}
